import { useAppDispatch, useAppSelector } from '../state/hooks'
import { setCheckoutState } from '../state/Slices/checkoutSlice'
import { clearCart, setPersistedState, resetCouponState } from '../state/Slices/persistedSlice'

export const useEmptyCart = () => {
	const dispatch = useAppDispatch()
	const { posLoyaltyEnabled } = useAppSelector(state => state.settings)

	return () => {
		dispatch(
			setCheckoutState({
				orderNote: '',
				tipCount: 0,
				showNotes: false,
				isTaxesExpanded: false,
				phoneNumber: '',
				isGuestCheckout: false,
				orderCreated: false,
				pointsEarned: 0,
				showKioskLoyaltyEntry: posLoyaltyEnabled,
				isCardValid: false,
				selectedTip: null,
				isOrderProcessing: false,
			})
		)
		dispatch(resetCouponState())

		dispatch(
			setPersistedState({
				redeemedRewards: [],
				couponCode: '',
				couponCodeBackup: '',
				couponCodeDisplay: '',
			})
		)

		//dispatch(setDataState({ showKioskStartScreen: true }))

		dispatch(clearCart())
	}
}
